


import Logo from './../images/logo.png';
import ShareBackground from './../images/share-background.png';



import React from 'react';
import { useState, useEffect } from 'react';
import { useRef } from 'react';


import './../global-variables.scss';
import ordinal from './../util/ordinal-numbers.jsx';


const ShareCanvas = ({ personalityData, isPaid, canvasRef, canvasWidth, canvasHeight, opeTitle, opeLogo, conTitle, conLogo, extTitle, extLogo, agrTitle, agrLogo, staTitle, staLogo }) => {


  //console.log("canvas width = " + canvasWidth + "canvas height = " + canvasHeight );

  const iconSize = canvasWidth * 0.08;
  const iconSizeHalf = iconSize / 2;

  const heightSection = canvasHeight / 10;

  const opePercentile = personalityData.opePercentile;
  const conPercentile = personalityData.conPercentile;
  const extPercentile = personalityData.extPercentile;
  const agrPercentile = personalityData.agrPercentile;
  const staPercentile = personalityData.staPercentile;

  let opePercentileText = opePercentile + ordinal(opePercentile) + ' percentile';
  let conPercentileText = conPercentile + ordinal(conPercentile) + ' percentile';
  let extPercentileText = extPercentile + ordinal(extPercentile) + ' percentile';
  let agrPercentileText = agrPercentile + ordinal(agrPercentile) + ' percentile';
  let staPercentileText = staPercentile + ordinal(staPercentile) + ' percentile';
  if (!isPaid) {
    opePercentileText = '';
    conPercentileText = '';
    extPercentileText = '';
    agrPercentileText = '';
    staPercentileText = '';
  }


  useEffect(() => {

    const canvas = canvasRef.current;
    if (!canvas) return;
    const ctx = canvas.getContext('2d');

    ctx.clearRect(0, 0, canvasWidth, canvasHeight);


    ctx.fillStyle = '#242644';
    ctx.fillRect(0, 0, canvasWidth, canvasHeight);

    ctx.textAlign = 'center';
    ctx.textBaseline = 'middle';
    ctx.fillStyle = "white";
    ctx.font = '500 30px Open Sans';
    ctx.fillText("My Big Five results", canvasWidth / 2, heightSection);

    ctx.font = '18px Open Sans';
    ctx.textBaseline = 'middle';
    ctx.fillText(opeTitle, canvasWidth / 5, (heightSection * 2) + iconSize * 1.5);
    ctx.font = '16px Open Sans';
    ctx.fillStyle = '#B7B7B7';
    ctx.fillText(opePercentileText, canvasWidth / 5, (heightSection * 2) + iconSize * 2);

    ctx.font = '18px Open Sans';
    ctx.fillStyle = "white";
    ctx.fillText(conTitle, (canvasWidth / 5) * 2.5, (heightSection * 2) + iconSize * 1.5);
    ctx.font = '16px Open Sans';
    ctx.fillStyle = '#B7B7B7';
    ctx.fillText(conPercentileText, (canvasWidth / 5) * 2.5, (heightSection * 2) + iconSize * 2);

    ctx.font = '18px Open Sans';
    ctx.fillStyle = "white";
    ctx.fillText(extTitle, (canvasWidth / 5) * 4, (heightSection * 2) + iconSize * 1.5);
    ctx.font = '16px Open Sans';
    ctx.fillStyle = '#B7B7B7';
    ctx.fillText(extPercentileText, (canvasWidth / 5) * 4, (heightSection * 2) + iconSize * 2);

    ctx.font = '18px Open Sans';
    ctx.fillStyle = "white";
    ctx.fillText(agrTitle, (canvasWidth / 3), (heightSection * 5) + iconSize * 1.5);
    ctx.font = '16px Open Sans';
    ctx.fillStyle = '#B7B7B7';
    ctx.fillText(agrPercentileText, (canvasWidth / 3), (heightSection * 5) + iconSize * 2);

    ctx.font = '18px Open Sans';
    ctx.fillStyle = "white";
    ctx.fillText(staTitle, (canvasWidth / 3) * 2, (heightSection * 5) + iconSize * 1.5);
    ctx.font = '16px Open Sans';
    ctx.fillStyle = '#B7B7B7';
    ctx.fillText(staPercentileText, (canvasWidth / 3) * 2, (heightSection * 5) + iconSize * 2);

    ctx.textAlign = 'left';
    ctx.textBaseline = 'left';
    ctx.font = '16px Open Sans';
    ctx.fillStyle = '#B7B7B7';
    ctx.fillText("Find out your results:", (canvasWidth / 2) - 40, canvasHeight - 60);
    ctx.fillStyle = 'white';
    ctx.fillText("https://thebigfive.app", (canvasWidth / 2) - 40, canvasHeight - 40);



    const backgroundImg = new Image();

    backgroundImg.onload = () => {
      ctx.drawImage(backgroundImg, 0, 0, canvasWidth, canvasHeight);
    };

    backgroundImg.src = ShareBackground;

    //ctx.drawImage(O, 400, 100);

    const opeImg = new Image();

    opeImg.onload = () => {

      if (personalityData.ope == 4) {
        ctx.drawImage(opeImg, ((canvasWidth / 5)) - iconSizeHalf, (heightSection * 2) - (iconSize * 0.2), iconSize, iconSize * 1.2);
      }
      else {
        ctx.drawImage(opeImg, (canvasWidth / 5) - iconSizeHalf, heightSection * 2, iconSize, iconSize);
      }
    };

    opeImg.src = opeLogo;

    const conImg = new Image();

    conImg.onload = () => {

      if (personalityData.con == 4) {
        ctx.drawImage(conImg, ((canvasWidth / 5) * 2.5) - iconSizeHalf, (heightSection * 2) - (iconSize * 0.2), iconSize, iconSize * 1.2);
      }
      else {
        ctx.drawImage(conImg, ((canvasWidth / 5) * 2.5) - iconSizeHalf, heightSection * 2, iconSize, iconSize);
      }
    };

    conImg.src = conLogo;

    const extImg = new Image();

    extImg.onload = () => {

      if (personalityData.ext == 4) {
        ctx.drawImage(extImg, ((canvasWidth / 5) * 4) - iconSizeHalf, (heightSection * 2) - (iconSize * 0.2), iconSize, iconSize * 1.2);
      }
      else {
        ctx.drawImage(extImg, ((canvasWidth / 5) * 4) - iconSizeHalf, heightSection * 2, iconSize, iconSize);
      }


    };

    extImg.src = extLogo;

    const agrImg = new Image();

    agrImg.onload = () => {

      if (personalityData.agr == 4) {
        ctx.drawImage(agrImg, ((canvasWidth / 3) ) - iconSizeHalf, (heightSection * 5) - (iconSize * 0.2), iconSize, iconSize * 1.2);
      }
      else {
        ctx.drawImage(agrImg, ((canvasWidth / 3)) - iconSizeHalf, heightSection * 5, iconSize, iconSize);
      }
    };

    agrImg.src = agrLogo;

    const neuImg = new Image();

    neuImg.onload = () => {
      if (personalityData.neu == 4) {
        ctx.drawImage(neuImg, ((canvasWidth / 3) * 2) - iconSizeHalf, (heightSection * 5) - (iconSize * 0.2), iconSize, iconSize * 1.2);
      }
      else {
        ctx.drawImage(neuImg, ((canvasWidth / 3) * 2) - iconSizeHalf, heightSection * 5, iconSize, iconSize);
      }
    };

    neuImg.src = staLogo;


    const logoImg = new Image();

    logoImg.onload = () => {
      ctx.drawImage(logoImg, (canvasWidth / 3), canvasHeight - (heightSection * 1.7), 60, 70);
    };

    logoImg.src = Logo;

  }, [personalityData]);

}


export default ShareCanvas;